import { FC } from 'react';
import { Button, Typography } from '@wellstone-solutions/web';
import { Trans } from 'react-i18next';

import { Title } from '@modules/auth/components/Title';
import { useAuthStore } from '@modules/auth/store/auth-store';

interface TokenExpiredProps {
  onResend: () => void;
}

export const TokenExpired: FC<TokenExpiredProps> = ({ onResend }) => {
  const { userInfo } = useAuthStore();

  return (
    <>
      <Title>
        <Trans i18nKey="auth.verify.token_expired">Link expired.</Trans>
      </Title>

      <Typography variant="h2" sx={styles.subtitle}>
        <Trans i18nKey="auth.verify.try_new">Try a new one...</Trans>
      </Typography>

      <Typography sx={styles.info}>
        <Trans i18nKey="auth.verify.expired_message">
          The validation link that you used has expired. Click the button below
          to get a new email with a validation link.
        </Trans>
      </Typography>

      {userInfo?.email && (
        <Typography sx={styles.email}>
          <Trans
            i18nKey="auth.verify.sent_to"
            values={{ email: userInfo.email }}
            components={{ span: <span /> }}
            defaultValue="Verification email sent to <span>{{email}}</span>"
          />
        </Typography>
      )}

      <Typography sx={styles.info}>
        <Trans i18nKey="auth.verify.expiry">
          👉 Heads up! The link will expire in 15 minutes.
        </Trans>
      </Typography>

      <Button
        variant="outlined"
        fullWidth
        onClick={onResend}
        sx={styles.resendButton}>
        <Trans i18nKey="auth.verify.resend">Resend email</Trans>
      </Button>
    </>
  );
};

const styles = {
  resendButton: {
    maxWidth: 400,
    margin: '0 auto',
    display: 'block',
  },
  subtitle: {
    fontSize: '1.5rem',
    textAlign: 'center',
    marginBottom: 3,
  },
  email: {
    textAlign: 'center',
    marginBottom: 3,
    fontStyle: 'italic',
  },
  info: {
    textAlign: 'center',
    marginBottom: 4,
  },
};
